import { CallCenter } from 'views';
import {LiveCalls} from 'views';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LiveCalls />} path="/" />
        <Route element={<CallCenter />} path="/call-center" />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
